// Notification preferences (mirrored to server prefs.sound / prefs.desktopNotify) + desktop notification helper
const KEY = "ali_notify";
export function getNotifySettings() {
  try { return { sound: false, desktop: false, ...(JSON.parse(localStorage.getItem(KEY)) || {}) }; } catch { return { sound: false, desktop: false }; }
}
export function setNotifySettings(patch) {
  const s = { ...getNotifySettings(), ...patch };
  try { localStorage.setItem(KEY, JSON.stringify(s)); } catch {}
  window.dispatchEvent(new CustomEvent("ali-notify", { detail: s }));
  return s;
}
/* 桌面弹窗「只弹 @ 我 · 回复我」（2026-10-23 用户需求）
   原话：「设计部项目管理需要在每个阶段的聊天，聊天中有电脑系统的提示，只弹出艾特自己的」。
   设计部阶段会话里，除了人写的评论，还会持续产生系统自动提醒（交图复核、状态变化、
   审批、逾期、摘要…）。这些留在铃铛里已经够用，再弹到电脑桌面只会把聊天刷屏。
   口径：
     · 设计类提醒（type 以 `design` 开头）= 只有评论类（后端 category=comment，
       即 @提及 / 回复）才弹；
     · 其它模块（工程 / CRM / HRMS…）不做任何过滤，保持原样全弹 —— 需求只针对设计阶段聊天。
   `category` 由后端 /reminders 逐条计算（reminder_category.category_of），
   老数据没有该字段时按 system 处理 —— 宁可少弹一条，也不要把系统噪音重新放回来。 */
export const popDesktopFor = (r) => {
  const type = String(r?.type || "");
  if (!type.startsWith("design")) return true;
  return (r?.category || "system") === "comment";
};
export const desktopSupported = () => typeof window !== "undefined" && "Notification" in window;
export async function ensureDesktopPermission() {
  if (!desktopSupported()) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  try { return await Notification.requestPermission(); } catch { return "denied"; }
}
export function showDesktopNotification(title, body, onClick) {
  if (!desktopSupported() || Notification.permission !== "granted") return null;
  try {
    const n = new Notification(title, { body, icon: "/icon-192.png", badge: "/icon-192.png", tag: `ali-${Date.now()}` });
    n.onclick = () => { try { window.focus(); } catch {} onClick?.(); n.close(); };
    return n;
  } catch { return null; }
}
